import React, { useCallback, useState } from 'react';
import { Toggle, ToggleWrapper } from 'src/elements/inputs/ToggleInput.styles';

export interface ToggleValueOption {
  label: string;
  value: string;
}

interface ToggleInputProps {
  options: ToggleValueOption[];
  onChange: (chosenValue: string) => void;
  toogleBackgroundColor?: string;
  toogleColor?: string;
}

const ToggleInput = ({ options, onChange, toogleBackgroundColor, toogleColor }: ToggleInputProps): JSX.Element => {
  const [ activeValue, toggleValue ] = useState<string>();
  const [ isSwitched, setIsSwitched ] = useState<boolean>();

  const onClick = useCallback(() => {
    let newValue: string;
    if (!activeValue || activeValue === options[0].value) {
      setIsSwitched(true);
      newValue = options[1].value;
    } else {
      setIsSwitched(false);
      newValue = options[0].value;
    }

    toggleValue(newValue);
    onChange(newValue);
  }, [ activeValue, options ]);

  const optionA = options[0];
  const optionB = options[1];

  return (
    <ToggleWrapper>
      <div>{optionA.label}</div>
      <Toggle onClick={onClick} switched={isSwitched} toogleBackgroundColor={toogleBackgroundColor} toogleColor={toogleColor} />
      <div>{optionB.label}</div>
    </ToggleWrapper>
  );
};

export default ToggleInput;
